const OTPConfig = {
  NUMBER_OF_OTP_INPUTS: 6,
};

export default OTPConfig;
